import { render } from "./CartaCursoInscrito.vue?vue&type=template&id=4061082d&scoped=true"
import script from "./CartaCursoInscrito.vue?vue&type=script&lang=js"
export * from "./CartaCursoInscrito.vue?vue&type=script&lang=js"

import "./CartaCursoInscrito.vue?vue&type=style&index=0&id=4061082d&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\Cursos\\descargaConstancia\\descargaconstancia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4061082d"]])

export default __exports__